<template lang="html">
    <div>
       <v-toolbar text color="white">
        <v-toolbar-title>NATURE OF TRANSACTIONS CODES ({{getData.length}})</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <br>
         <v-card-title class="justify-content-end">
            <v-flex md4 pr-2 >
                <v-text-field v-model="search" label="Search"
                append-icon="mdi-magnify" single-line hide-details ></v-text-field>
            </v-flex>
        </v-card-title>
      <v-data-table :headers="headers" :items="getData" 
           :search="search" class="elevation-1">
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-right" >{{ props.item.natureOfTransactionCode }}</td>
            <td class="text-xs-right">{{ props.item.aMandatory }}</td>
            <td class="text-xs-right">{{ props.item.bOptional }}</td>
          </tr>
        </template>
<template v-slot:no-data>
          <span>No data found</span>
        </template>
</v-data-table>

</div>
</template>

<script>
    import MasterScreenService from "../../services/master-screenservices"

    export default {
        name: 'NatureOfTransactions',
        data() {
            return {
                search: '',
                getData: [],
                headers: [{
                    text: "Code",
                    align: "left",
                    sortable: true,
                    value: "natureOfTransactionCode"
                }, {
                    text: "A(Mandatory)",
                    align: "left",
                    sortable: true,
                    value: "aMandatory"
                }, {
                    text: "B(Optional)",
                    align: "left",
                    sortable: true,
                    value: "bOptional"
                }, ],
            }
        },
        computed: {},
        created() {
            MasterScreenService.getNatureOfTransactions().then(response => {
                    this.getData = response.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },

        methods: {}
    }
</script>

<style>
    .justify-content-end {
        justify-content: Flex-end;
    }
    
    th.text-left.sortable {
        min-width: 80px;
    }
</style>